export let IDB_globalDb: IDBDatabase

export const IDB_globalDbSet = (db: IDBDatabase) => (IDB_globalDb = db)
